<template>
  <div class="loader">
    <div
      v-for="i in 8"
      :key="i"
      class="loader__item"
      :class="{ 'loader__item--dark': dark }"
      :style="{ transform: `rotate(${i * 45}deg)`, '--animation-delay': `${i / -10}s` }" />
  </div>
</template>

<script>
export default {
  name: "LoadingIcon",
  props: {
    dark: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/style/_variables.scss';
@keyframes circleFade {
  0%,
  39%,
  100% {
    opacity: 0;
  }
  40% {
    opacity: 1;
  }
}

.loader {
  position: relative;
  width: 100%;
  height: 100%;

  &__item {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;

    &::before {
      content: '';
      display: block;
      margin: 0 auto;
      width: 15%;
      height: 30%;
      background-color: $white;
      border-radius: 100%;
      animation: circleFade 0.8s infinite ease-in-out both;
      animation-delay: var(--animation-delay);
    }

    &--dark {
      &::before {
        background-color: $blue-active;
      }
    }
  }
}
</style>
